/* istanbul ignore file */

import animationManager, {
  AnimationStatusCallbacks,
  makeSequence,
  SequenceStep,
} from "../../../../../../shared/services/animation-manager";
import { AnimationSequences } from "../../../../../../shared/utility/constants";

export default function registerCloseSingleDrawerAnimation({
  onAnimationStarts,
  onAnimationEnds,
}: Required<AnimationStatusCallbacks>): void {
  const sequence: SequenceStep[] = [
    [
      {
        onStart: onAnimationStarts,
        elementSelector: "phn-nd-single-drawer",
        animation: {
          className: "translate-out-to-left",
          cleanUpBeforeAnimation: (element) => {
            element.style.translate = "";
          },
          cleanUpAfterAnimation: (element) => {
            element.style.translate = "-1000px";
          },
        },
      },
      {
        elementSelector: "phn-nd-backdrop",
        animation: {
          className: "fade-out-animation",
          cleanUpBeforeAnimation: (element) => {
            element.style.backgroundColor = "";
            element.style.opacity = "";
          },
        },
        onEnd: onAnimationEnds,
      },
    ],
  ];

  animationManager.register(
    AnimationSequences.CLOSE_SINGLE_DRAWER,
    makeSequence(sequence),
  );
}
